/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *******************************************************************************/

import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@mui/styles';
import { Card, CardContent, Container } from '@mui/material';


const styles = makeStyles(theme => ({
    root: {
    },
    cardContent: {
        margin: '20px',
    },
    imageDotedDescp: {
        transition: 'transform .2s',
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'block',
        "&:hover": {
            transform: 'scale(1.2)',

        }
    },
    sectionTitleBorder: {
        width: '50px',
        height: '2px',
        marginRight: 'auto',
        marginLeft: 'auto',
        backgroundColor: '#fb743e',

    },
    divinfoNavigation: {
        marginTop: '100px'
    },
    blocksTypoInfo: {
        lineHeight: "2.5em!important"
    },
    socialIconsList: {
        background: '#0b0b1e6e!important',
        paddingBottom: '30px!important'

    }
}));


const Contactus = () => {
    const classes = styles();

    return (
        <>

            <Grid container spacing={4}>

                <Grid item xs={12} sm={12} md={12}  >
                    <div >
                        <Typography variant="h1" align="center" style={{ color: "white", marginTop: '100px', marginBottom: '20px' }} paragraph>
                            Contact Us
                        </Typography>
                        <div className={classes.sectionTitleBorder}></div>
                        <div className={classes.divinfoNavigation}>

                            <Container className={classes.cardGrid} maxWidth="lg">
                                {/* End hero unit */}
                                <Grid container spacing={4}>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <Card className={classes.cardService} >
                                            <CardContent className={classes.cardContent}>

                                                <img src="assets/images/Logo/logo.png" style={{ width: "200px", heignt: "200px" }} className='AlignCenter' />

                                                <Typography variant="h3" color="text.primary" align="center" style={{ marginTop: "20px" }}>
                                                    Email : info@theraytek.tn
                                                </Typography>
                                                <Typography variant="h3" color="text.primary" align="center" style={{ marginTop: "20px" }}>
                                                    Address  : AV. HAJ ALI SOUA KSAR-HELLAL 5070, Monastir, Tunisia.
                                                </Typography>
                                                <Typography variant="h3" color="text.primary" align="center" style={{ marginTop: "10px" }}>
                                                    Phone Number  : + (216) 24 527 298
                                                </Typography>
                                            </CardContent>
                                            <Grid item xs={12} sm={12} md={12}>

                                                <Grid container
                                                    direction="row"
                                                    justify="center"
                                                    alignItems="center"
                                                    spacing={4}
                                                    className={classes.socialIconsList}
                                                >
                                                    <Grid item xs={2} sm={5}>
                                                    </Grid>
                                                    <Grid item xs={2} sm={1}>
                                                        <a href="https://www.linkedin.com/company/theraytek" target="_blank" rel="noreferrer">
                                                            <img src="/assets/images/icons/linkedin.png" width={40} alt="linkedin" />
                                                        </a>
                                                    </Grid>


                                                    <Grid item xs={2} sm={1}>

                                                        <a href="mailto:info@theraytek.tn" target="_blank" rel="noreferrer">
                                                            <img src="/assets/images/icons/email.png" width={40} alt="email" />
                                                        </a>
                                                    </Grid>
                                                    <Grid item xs={4} sm={5} >
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                        </Card>
                                    </Grid>

                                </Grid>
                            </Container>

                        </div>
                    </div>
                </Grid>

            </Grid>

        </>
    );
}



export default Contactus;